import React from 'react';
import './Spinner.css'
import logo from './assets/compasstransparent100.png'

// Compass Spinner
// Use Images and SVG to Draw a Compass and change the degrees
// it points to.
// Copyright W Burey 2020
//
export default function Compass(props) {
    let mystyle = {
        transform: `rotate(${props.degrees}deg)`,
        top: `24px`,
        marginLeft: `46px`,
        height: `94px`,
        width: `5px`,
    }

  return (
    <div className="img-overlay-wrap">
    <img id='pointer' src={logo} alt="Logo"  style={mystyle} />
    <svg viewBox="0 0 100 100" width="100">
    <circle className="spinner circle" cx="50" cy="50" r="45"/>
    <text x="45" y ="10" fill="red" fontSize="10">N</text>
    <text x="45" y ="100" fill="blue" fontSize="10">S</text>
    <text x="90" y ="52" fill="black" fontSize="10">E</text>
    <text x="0" y ="52" fill="black" fontSize="10">W</text>
    </svg>
    </div>
  );
}
